import createSvgIcon from '../Utils/CreateSvgIcon';

export const Images = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.25 4.5H6.75C6.33579 4.5 6 4.83579 6 5.25V15.75C6 16.1642 6.33579 16.5 6.75 16.5H20.25C20.6642 16.5 21 16.1642 21 15.75V5.25C21 4.83579 20.6642 4.5 20.25 4.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.125 9C16.7463 9 17.25 8.49632 17.25 7.875C17.25 7.25368 16.7463 6.75 16.125 6.75C15.5037 6.75 15 7.25368 15 7.875C15 8.49632 15.5037 9 16.125 9Z"
      fill="currentColor"
    />
    <path
      d="M6 12.0647L9.59437 8.46935C9.66403 8.39962 9.74675 8.3443 9.83779 8.30656C9.92884 8.26882 10.0264 8.24939 10.125 8.24939C10.2236 8.24939 10.3212 8.26882 10.4122 8.30656C10.5033 8.3443 10.586 8.39962 10.6556 8.46935L15.3103 13.125L17.7188 10.7194C17.8594 10.5788 18.0501 10.4999 18.2489 10.4999C18.4477 10.4999 18.6384 10.5788 18.7791 10.7194L21 12.9431"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 16.5V18.75C18 18.9489 17.921 19.1397 17.7803 19.2803C17.6397 19.421 17.4489 19.5 17.25 19.5H3.75C3.55109 19.5 3.36032 19.421 3.21967 19.2803C3.07902 19.1397 3 18.9489 3 18.75V8.25C3 8.05109 3.07902 7.86032 3.21967 7.71967C3.36032 7.57902 3.55109 7.5 3.75 7.5H6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'Images',
);
